import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { AuctionCategory } from 'types/domain';

interface DeleteAuctionCategoryDialogProps extends AlertDialog.AlertDialogRootProps {
    onDelete?: () => void;
    hasItems: AuctionCategory['has_items'];
}

const DeleteAuctionCategoryDialog = (props: DeleteAuctionCategoryDialogProps) => {
    const { hasItems, children, onDelete, ...rest } = props;

    return (
        <AlertDialog.Root type={'error'} {...rest}>
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Delete category?</AlertDialog.Title>
                        <AlertDialog.Description>
                            {hasItems
                                ? 'You have existing items in this category. Deleting will remove the category from those items and they will be listed with other items without category labels. This will also make items visible to bidders if the category is currently hidden.'
                                : 'This action is irreversible and this category will be removed from your auction.'}
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
                        <AlertDialog.Action onClick={() => onDelete?.()}>Delete</AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const DeleteAuctionCategoryDialogTrigger = AlertDialog.Trigger;

const Root = DeleteAuctionCategoryDialog;
const Trigger = DeleteAuctionCategoryDialogTrigger;

export {
    DeleteAuctionCategoryDialog,
    DeleteAuctionCategoryDialogTrigger,
    //
    Root,
    Trigger,
};
